import { NAME as APP_NAME } from 'constants';

import { AUTHORITIES } from 'domain/fuse/auth/constants';

export const NAME = `${APP_NAME}/FLEETS`;

export const REDUCER_NAME = 'fleets';

export const END_POINT = '/api/fleet/query';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}${END_POINT}`;

export const ROUTES = {
  ROOT: '/fleets',
};

export const MANAGERS_ROLES = `${AUTHORITIES.ACCOUNT_ADMIN},${AUTHORITIES.DOMAIN_ADMIN},${AUTHORITIES.FLEET_ADMIN},${AUTHORITIES.OPERATOR},${AUTHORITIES.DISPATCHER},${AUTHORITIES.SECURITY_GUARD}`;
